import { Component } from "react";
import config from "./config/app.config";
import { ExportOutlined } from "@ant-design/icons";
import { Alert, Button, Space } from "antd";
import { Link } from "react-router-dom/cjs/react-router-dom";
import dayjs from "dayjs";

const alertMessage = (
  <>
    มีการอัปเดตเวอร์ชันใหม่แล้ว! <br />
    โปรดตรวจสอบการเปลี่ยนแปลงล่าสุด. <br />
  </>
);

let updateDate = config?.updateDate;
let version = config.version;
let lastVersion = config.lastVersion;
let tagsStatus = document.getElementById("tagsStatus");

class UpdateAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlert: true,
      countdown: 30, // เพิ่ม state สำหรับตัวนับถอยหลัง
    };
    this.timer = null; // เก็บค่า timer ID เพื่อใช้ในการเคลียร์
  }

  componentDidMount() {
    // ตรวจสอบวันที่อัปเดท
    const now = dayjs();
    const updateDateObj = dayjs(updateDate);
    const hoursSinceUpdate = now.diff(updateDateObj, "hour");

    if (hoursSinceUpdate > 72) {
      this.setState({ showAlert: false });
      if (tagsStatus) {
        tagsStatus.innerText = "ล่าสุด";
      }
      return;
    }

    // ตรวจสอบ localStorage และถ้าไม่มี ให้เริ่มตัวนับ
    if (tagsStatus) {
      tagsStatus.innerText = "New";
    }
    const doNotShowAgain = localStorage.getItem(
      `doNotShowAlertVersion:${version}`
    );
    if (doNotShowAgain === "true") {
      this.setState({ showAlert: false });
    } else {
      // เริ่มนับถอยหลังอัตโนมัติหากมีการแสดง Alert
      this.startCountdown();
    }
  }

  // เคลียร์ timer เมื่อ component กำลังจะถูก unmount
  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  // ฟังก์ชันสำหรับเริ่มนับถอยหลัง
  startCountdown = () => {
    this.timer = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.countdown === 1) {
          clearInterval(this.timer); // หยุด timer
          this.handleCloseAlert(); // ปิด Alert อัตโนมัติ
        }
        return { countdown: prevState.countdown - 1 };
      });
    }, 1000); // 1 วินาที
  };

  // ฟังก์ชันสำหรับจัดการการปิด Alert โดยผู้ใช้
  handleCloseAlert = () => {
    // เมื่อ Alert ถูกปิด ให้ทำการเคลียร์ timer
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.setState({ showAlert: false });
  };

  // ฟังก์ชันสำหรับจัดการการคลิก "ไม่ต้องแสดงอีก"
  handleDoNotShowAgain = () => {
    const last = localStorage.getItem(`doNotShowAlertVersion:${lastVersion}`);
    if (last) {
      localStorage.removeItem(`doNotShowAlertVersion:${lastVersion}`);
    }
    localStorage.setItem(`doNotShowAlertVersion:${version}`, "true");
    this.handleCloseAlert(); // เรียกใช้ handleCloseAlert เพื่อปิดและเคลียร์ timer
  };

  // Method สำหรับ Render UI
  render() {
    const { showAlert } = this.state;
    if (!showAlert) {
      return null;
    }

    return (
      <div id="mainAlert" style={styles.alertContainer}>
        <Alert
          message={`NEW Version: ${version}`}
          showIcon
          description={<>{alertMessage}</>}
          type="info"
          action={
            <Space direction="vertical">
              <Button size="small" type="primary">
                <Link to="/updateList">
                  <span
                    style={{ fontSize: "13px", color: "#fff", border: "none" }}
                  >
                    เวอร์ชันใหม่ <ExportOutlined />
                  </span>
                </Link>
              </Button>
              <Button  size="small" onClick={this.handleDoNotShowAgain}>
                ไม่ต้องแสดงอีก
              </Button>
            </Space>
          }
          // ปรับปรุงการแสดงผลของ closable และ onClose
          closable={true}
          onClose={this.handleCloseAlert}
          
        />
      </div>
    );
  }
}

// CSS-in-JS สำหรับ Component
const styles = {
  alertContainer: {
    position: "fixed",
    top: "20px",
    right: "37px",
    zIndex: "1000",
  },
  alertContent: {
    backgroundColor: "#333",
    color: "white",
    padding: "15px 25px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    maxWidth: "300px",
    textAlign: "center",
    fontFamily: "sans-serif",
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "10px 0",
  },
  checkbox: {
    marginRight: "8px",
  },
  label: {
    fontSize: "14px",
    color: "rgb(62 172 255)",
  },
  closeButton: {
    backgroundColor: "#555",
    color: "white",
    border: "none",
    borderRadius: "4px",
    padding: "8px 16px",
    cursor: "pointer",
    marginTop: "10px",
  },
};

export default UpdateAlert;
